function wrap(alert) {
  return typeof alert === 'object'
    ? alert
    : { text: alert }
}

export default {
  store: {
    state: {
      list: [],
    },
    actions: {
      ALERT({ commit, dispatch }, alert) {
        commit('ADD_ALERT', alert)

        // auto close general alerts
        if (['success', 'info'].includes(alert.theme)) {
          setTimeout(() => {
            dispatch('CLOSE_ALERT', alert)
          }, 5000)
        }

        return Promise.resolve()
      },
      SUCCESS({ dispatch }, text) {
        return dispatch('ALERT', { theme: 'success', ...wrap(text) })
      },
      DANGER({ dispatch }, text) {
        return dispatch('ALERT', { theme: 'danger', ...wrap(text) })
      },
      CLOSE_ALERT({ commit }, alert) {
        commit('REMOVE_ALERT', alert)
        return Promise.resolve()
      },
    },
    mutations: {
      ADD_ALERT(state, alert) {
        state.list.push(alert)
      },
      REMOVE_ALERT(state, { text }) {
        state.list = state.list.filter(alert => alert.text !== text)
      },
    },
    getters: {
      alerts: state => state.list,
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/alerts.js